import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthentificationService } from './authentification.service';

@Injectable({providedIn: 'root'})
export class AuthentificationGuard  {

  constructor(private router: Router, private authService: AuthentificationService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

   if (this.authService.isUtilisateurAuthentifie()) {
      // ... sinon, on regarde si l'utilisateur est déjà authentifié...
      //this.router.navigate(['/saisie']);
      return true ;
    } else {
      // ...et à défaut, on redirige vers la page d'authentification.
      this.router.navigate(['']);
      return false ;
    }
  }
}
